import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import Button from '../../../common/button/Button';

const HeaderBar = ({ headerBarLink, headerBarStartColor, headerBarEndColor, headerBarTitle, headerBarText }) => {
    const isMaintenance = process.env.MAINTENANCE_MODE === 'true';

    const externalLink = headerBarLink && headerBarLink.indexOf('http') > -1;
    const style = {
        background: isMaintenance ? '#700109' : `linear-gradient(90deg,${headerBarStartColor},${headerBarEndColor})`,
    };

    return (
        <div className="headerBar" style={style}>
            <div className="headerBarContainer">
                {
                    isMaintenance ?
                        <p>Estamos em manutenção. Em Breve todas as funcionalidades voltarão ao normal.</p>
                        :
                        <Button
                            className="headerBarButton"
                            to={externalLink ? undefined : headerBarLink}
                            href={externalLink ? headerBarLink : undefined}
                            title={headerBarTitle}
                        >
                            <span>
                                {headerBarText}
                            </span>
                            {' '}

                        </Button>
                }
            </div>
        </div>
    );
};

HeaderBar.propTypes = exact({
    headerBarText: PropTypes.string.isRequired,
    headerBarTitle: PropTypes.string.isRequired,
    headerBarLink: PropTypes.string.isRequired,
    headerBarStartColor: PropTypes.string.isRequired,
    headerBarEndColor: PropTypes.string.isRequired,
});

export default HeaderBar;
